var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattery1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "23.281px",
    height: "12.906px",
    viewBox: "0 0 23.281 12.906",
    enableBackground: "new 0 0 23.281 12.906",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#646464",
    strokeWidth: 1.9798,
    strokeMiterlimit: 10,
    d: "M20.803,9.953c0,1.089-0.891,1.98-1.98,1.98 H2.985c-1.089,0-1.98-0.891-1.98-1.98V2.99c0-1.089,0.891-1.98,1.98-1.98h15.839c1.089,0,1.98,0.891,1.98,1.98V9.953z"
  })), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#FF0000",
    strokeWidth: 1.9798,
    strokeMiterlimit: 10,
    x1: 4.965,
    y1: 3.834,
    x2: 4.965,
    y2: 9.109
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#646464",
    strokeWidth: 1.9798,
    strokeMiterlimit: 10,
    x1: 8.924,
    y1: 3.834,
    x2: 8.924,
    y2: 9.109
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#646464",
    strokeWidth: 1.9798,
    strokeMiterlimit: 10,
    x1: 12.884,
    y1: 3.834,
    x2: 12.884,
    y2: 9.109
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#646464",
    strokeWidth: 1.9798,
    strokeMiterlimit: 10,
    x1: 16.844,
    y1: 3.834,
    x2: 16.844,
    y2: 9.109
  }), /*#__PURE__*/React.createElement("line", {
    fill: "#231F20",
    stroke: "#646464",
    strokeWidth: 2.9697,
    strokeMiterlimit: 10,
    x1: 21.793,
    y1: 3.834,
    x2: 21.793,
    y2: 9.109
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery1);
export default __webpack_public_path__ + "static/media/battery_1.aca2df714ce36605564b4e1ea4042ee1.svg";
export { ForwardRef as ReactComponent };